/* eslint-disable camelcase */
import { cloneDeep } from 'lodash';
import api from '../../api/hasura';
import { sendActiveCampaign } from '../../util/bot-utils';

const {
  default: Interceptor,
} = require('../../core/type/operation/Interceptor');

const createLeadProspect = (lead) => api({
  query: `#graphql
    mutation createLeadProspect (
        $lead: lead_prospect_insert_input!
      ) {
      insert_lead_prospect_one(object: $lead) {
        id
      }
    }
  `,
  variables: { lead },
}).then((res) => res.data.insert_lead_prospect_one);

const updateLeadProspectByPk = (id, data, append) => api({
  query: `#graphql
    mutation updateLeadProspectByPk($id: uuid!, $data: lead_prospect_set_input, $append: lead_prospect_append_input) {
      update_lead_prospect_by_pk(
        pk_columns:{
            id: $id
        },
        _set:$data,
        _append:$append
      ){
        id
      }
    }
    `,
  variables: {
    id,
    data,
    append,
  },
}).then((res) => res.data?.update_lead_prospect_by_pk);

export const sendBotResponse = (complete = false, extra = false) => new Interceptor(
  async (data) => new Promise(async (resolve) => {
    const now = new Date();
    const newData = cloneDeep(data);
    const { information, id } = newData;
    delete newData.information;
    delete newData.created_at;
    delete newData.updated_at;
    delete newData.project_contact_option;
    delete newData.options;
    delete newData.id;

    newData.status = complete ? 'NEW' : 'STARTED';

    if (!id) {
      newData.indications_count = 0;
      const lead = {
        created_at: now,
        updated_at: now,
        source: 'CLINTZ',
        fields: newData,
        information,
      };

      const resp = await createLeadProspect(lead);
      sendActiveCampaign({ ...newData, tags: complete ? 'clintz-finalizou' : 'clintz-iniciou' });
      resolve({ ...data, id: resp.id, updated_at: now });
    } else {
      updateLeadProspectByPk(
        id,
        {},
        {
          fields: newData,
          information,
        },
      );
      sendActiveCampaign({ ...newData, tags: complete ? 'clintz-finalizou' : 'clintz-iniciou' });
      resolve({ ...data, updated_at: now });
    }
  }),
);
